// API client del Contrato de Gobernanza Soberana — habla con el proxy de Orión
// (/orion/api/governance/*), que resuelve el org_id SERVER-SIDE desde el JWT
// (nunca del navegador). Mismo patrón de auth (Bearer de localStorage) que
// consolidation / memory-graph.

const ORION = '/orion/api';
const BASE = '/governance';

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token ?? ''}` };
}

// ── Tipos del contrato (GET /governance/contracts) ──
export interface ContractSent {
  org_id?: string;
  model?: string;
  grounded?: boolean | null;
  prompt_signature?: string | null;
  contract_signature?: string | null;
}
export interface ContractReceived {
  verdict?: string | null;
  seal?: Record<string, unknown> | null;
}
export interface GovernanceContract {
  timestamp?: string | null;
  session_id?: string | null;
  channel?: string | null;
  purpose?: string | null;
  sent: ContractSent;
  received: ContractReceived;
}
export interface ContractsResponse {
  org_id: string | null;
  contracts: GovernanceContract[];
}

async function req<T>(path: string): Promise<T> {
  const res = await fetch(`${ORION}${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const raw = (body as { detail?: unknown; error?: unknown }).detail
      ?? (body as { error?: unknown }).error;
    const msg = typeof raw === 'string' ? raw : raw ? JSON.stringify(raw) : `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return body as T;
}

export const governanceApi = {
  // org_id lo fija el proxy desde el JWT — jamás se manda desde el cliente.
  getContracts: (opts?: { sessionId?: string; limit?: number }) => {
    const p = new URLSearchParams();
    if (opts?.sessionId) p.set('session_id', opts.sessionId);
    p.set('limit', String(opts?.limit ?? 100));
    return req<ContractsResponse>(`/contracts?${p.toString()}`);
  },
};
